'use client'

import { Box, Flex, Text } from '@mantine/core'

import {
  formatChangePercent,
  getPercentChangeColor,
} from '@/app/[locale]/price/[slug]/_components/CoinLineChart/utils'
import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import AnimatedPrice from '@/components/AnimatedPrice'
import { useSsrContext } from '@/contexts/ssr'

interface StockChartInfoTitleProps {
  coinPrice?: number
  coinPercentChange?: number
  isMouseInChart: boolean
  curTimeRange?: string
}

export default function StockChartInfoTitle({
  coinPrice,
  coinPercentChange,
  isMouseInChart,
  curTimeRange,
}: StockChartInfoTitleProps) {
  const { coin } = useCoinContext()
  const { selectedCurrency } = useSsrContext()
  const changeColor = getPercentChangeColor(coinPercentChange ?? 0)
  const changeText = coinPercentChange ? formatChangePercent(coinPercentChange * 100) : void 0

  const priceDisplay = (key: string) => (
    <Flex align="baseline" gap={8} h={40}>
      <AnimatedPrice
        key={key}
        variant={'balances'}
        price={coinPrice}
        tokenSymbol={coin.symbol}
        disabledPriceAnimate={isMouseInChart}
        disabledConvert={isMouseInChart}
      />
      <Text variant={'body'} c={'#7B849B'}>
        {selectedCurrency}
      </Text>
    </Flex>
  )

  const changeDisplay = (
    <Box h={20}>
      <Flex align="baseline" gap={4}>
        <Text c={changeColor} variant={'body'}>
          {changeText}
        </Text>
        {changeText && curTimeRange && (
          <Text variant={'body'} c={'var(--content-secondary)'}>
            {curTimeRange}
          </Text>
        )}
      </Flex>
    </Box>
  )

  return (
    <>
      <Box visibleFrom="md">
        {priceDisplay('desktop')}
        {changeDisplay}
      </Box>
      <Box hiddenFrom="md">
        {priceDisplay('mobile')}
        {changeDisplay}
      </Box>
    </>
  )
}
